import React from 'react';
import { useTranslation } from 'react-i18next';

export type DeviceMode = 'arm' | '8051';

interface ModeSelectorProps {
  mode: DeviceMode;
  onModeChange: (mode: DeviceMode) => void;
  disabled?: boolean;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({ mode, onModeChange, disabled = false }) => {
  const { t } = useTranslation('webflash');

  const modes: { id: DeviceMode; label: string; description: string; icon: string }[] = [
    {
      id: 'arm',
      label: t('mode.arm'),
      description: t('mode.armDesc'),
      icon: 'ARM',
    },
    {
      id: '8051',
      label: t('mode.8051'),
      description: t('mode.8051Desc'),
      icon: '8051',
    },
  ];

  return (
    <div className="flex gap-4">
      {modes.map((m) => (
        <button
          key={m.id}
          onClick={() => onModeChange(m.id)}
          disabled={disabled}
          className={`flex-1 p-4 rounded-lg border-2 text-left transition-all ${
            mode === m.id
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
              : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="flex items-center gap-3">
            <span
              className={`inline-flex items-center justify-center w-10 h-10 rounded-lg text-xs font-bold ${
                mode === m.id
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
              }`}
            >
              {m.icon}
            </span>
            <div>
              <div className="font-medium text-gray-900 dark:text-white">{m.label}</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">{m.description}</div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ModeSelector;
